import { render, staticRenderFns } from "./mark.vue?vue&type=template&id=79dd0104&scoped=true&"
import script from "./mark.vue?vue&type=script&lang=ts&"
export * from "./mark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd0104",
  null
  
)

export default component.exports